<ng-container *ngFor="let applicant of mortgageApplication.Applicants;index as i; let isLast = last">

  <p class="bo-label-text">
    <span *ngIf="applicant.Forename">{{applicant.Forename}} </span>
    <span *ngIf="applicant.Surname">{{applicant.Surname}}</span>
  </p>

  <ng-container *ngIf="mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability()">
    <!-- 157 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [controlId]="'EventsWhichAffectExpenditureCode-' + i" [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.EventsWhichAffectExpenditure"
      [propertyNames]="['Applicant_'+i+'.EventsWhichAffectExpenditureCode']"
      [(value)]="applicant.EventsWhichAffectExpenditureCode"></boi-form-radio-button>

    <ng-container *ngIf="applicant.EventsWhichAffectExpenditureCode===referenceDataOptionLists.AnswerTypeYes">
      <!-- 158 -->
      <boi-form-textarea class="big-textarea"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.DetailsOfChangeExpenditure"
        [propertyNames]="['Applicant_'+i+'.DetailsOfChangeExpenditure']"
        [(value)]="applicant.DetailsOfChangeExpenditure" [fieldMaxLength]="1500"></boi-form-textarea>

      <!-- 159 -->
      <boi-form-textarea class="big-textarea"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.ImpactOnExpenditure" [propertyNames]="['Applicant_'+i+'.ImpactOnExpenditure']"
        [(value)]="applicant.ImpactOnExpenditure" [fieldMaxLength]="1500"></boi-form-textarea>

      <!-- 160 -->
      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.DateEffectOfExpenditure" [(value)]="applicant.DateEffectOfExpenditure"
        [propertyNames]="['Applicant_'+i+'.DateEffectOfExpenditure']"></boi-form-text-input>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <!-- 161 -->
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [controlId]="'BeenInArrearCode-'+i" [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.BeenInArrear" [propertyNames]="['Applicant_'+i+'.BeenInArrearCode']"
      [(value)]="applicant.BeenInArrearCode"></boi-form-radio-button>

    <ng-container *ngIf="applicant.BeenInArrearCode===referenceDataOptionLists.AnswerTypeYes">
      <!-- 161.1 -->
      <boi-form-textarea class="big-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.PleaseProvideDetails" [propertyNames]="['Applicant_'+i+'.BeenInArrearDetails']"
        [(value)]="applicant.BeenInArrearDetails" [fieldMaxLength]="1500"></boi-form-textarea>
    </ng-container>

    <!-- 162 -->
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [controlId]="'CourtJudgmentCode-'+i" [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.CourtJudgment" [propertyNames]="['Applicant_'+i+'.CourtJudgmentCode']"
      [(value)]="applicant.CourtJudgmentCode"></boi-form-radio-button>

    <ng-container *ngIf="applicant.CourtJudgmentCode===referenceDataOptionLists.AnswerTypeYes">
      <!-- 162.1 -->
      <boi-form-textarea class="big-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.PleaseProvideDetails"
        [propertyNames]="['Applicant_'+i+'.CourtJudgmentDetails']" [(value)]="applicant.CourtJudgmentDetails"
        [fieldMaxLength]="1500"></boi-form-textarea>
    </ng-container>

    <!-- 163 -->
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [controlId]="'BankruptCode-'+i" [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.Bankrupt" [propertyNames]="['Applicant_'+i+'.BankruptCode']"
      [(value)]="applicant.BankruptCode"></boi-form-radio-button>

    <ng-container *ngIf="applicant.BankruptCode===referenceDataOptionLists.AnswerTypeYes">
      <!-- 163.1 -->
      <boi-form-textarea class="big-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.PleaseProvideDetails" [propertyNames]="['Applicant_'+i+'.BankruptDetails']"
        [(value)]="applicant.BankruptDetails" [fieldMaxLength]="1500"></boi-form-textarea>
    </ng-container>

    <!-- 164 -->
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [controlId]="'ArrangementWithCreditorCode-'+i" [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.ArrangementWithCreditor"
      [propertyNames]="['Applicant_'+i+'.ArrangementWithCreditorCode']"
      [(value)]="applicant.ArrangementWithCreditorCode"></boi-form-radio-button>

    <ng-container *ngIf="applicant.ArrangementWithCreditorCode===referenceDataOptionLists.AnswerTypeYes">
      <!-- 164.1 -->
      <boi-form-textarea class="big-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.PleaseProvideDetails"
        [propertyNames]="['Applicant_'+i+'.ArrangementWithCreditorDetails']"
        [(value)]="applicant.ArrangementWithCreditorDetails" [fieldMaxLength]="1500"></boi-form-textarea>
    </ng-container>

    <!-- 165 -->
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [controlId]="'RefusedLoanCode-'+i" [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.RefusedLoan" [propertyNames]="['Applicant_'+i+'.RefusedLoanCode']"
      [(value)]="applicant.RefusedLoanCode"></boi-form-radio-button>

    <ng-container *ngIf="applicant.RefusedLoanCode===referenceDataOptionLists.AnswerTypeYes">
      <!-- 165.1 -->
      <boi-form-textarea class="big-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.PleaseProvideDetails" [propertyNames]="['Applicant_'+i+'.RefusedLoanDetails']"
        [(value)]="applicant.RefusedLoanDetails" [fieldMaxLength]="1500"></boi-form-textarea>
    </ng-container>
  </ng-container>
  <div *ngIf="!isLast" class="vo-separator-line my-30"></div>
</ng-container>
